import { useEffect, useState } from "react";
import { Row, Col, Table } from "reactstrap";
import { getElectricityInfo } from "../../../api/api";
import Spinner from "../../../commons/Spinner";
import { formatNumber, formatPower } from "../../../utils/NumberUtils";

const TableBattery = ({ selected, setSelected, deviceArr, deviceId }) => {

  const [pcsData, setPcsData] = useState(null);
  const authToken = localStorage.getItem('accessToken');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setPcsData(null);
    setIsLoading(true);
    const controller = new AbortController();
    const signal = controller.signal;

    const fetchData = async (signal) => {
      const data = await getElectricityInfo(authToken, deviceId, selected, signal);
      if (!data || data === null || data.comm_error) {
        setPcsData({
          bkup_power_min: "---",
          chrg_curr: "---",
          chrg_power: "---",
          chrg_volt: "---",
          real_power: "---",
          device_id: selected.device_id,
          dischrg_curr: "---",
          dischrg_power: "---",
          dischrg_volt: "---",
          event_code: "---",
          freq: "---",
          measured_time: "---",
          nominal_capacity: "---",
          power_factor: "---",
          soc: "---",
          soh: "---",
          sys_curr: "---",
          sys_power_received: "---",
          sys_power_send: "---",
          sys_volt: "---",
          time: "---",
          work_status: "---",
          status_code: "---"
        });
      } else {
        setPcsData(data);
      }
      setIsLoading(false);
    };
    const interval = setInterval(() => {
      fetchData(signal);
    }, 60000);
    fetchData(signal);
    return () => {
      clearInterval(interval);
      controller.abort();
    };
    //eslint-disable-next-line
  }, [selected]);


  return (
    <>
      {isLoading ? <Spinner /> : <Row>
        <Col md={2} lg={2} sm={2} xl={1} className="col-2 d-flex flex-row justify-content-end arrow-menu h-100">
          <div>
            <button
              className="btn_back"
              onClick={() => setSelected(null)}
            >
              <img src="/img/left.png" alt="leftArrow" className="m-2" />
            </button>
          </div>
          <div className="vl">

          </div>
        </Col>
        <Col md={10} lg={10} sm={10} xl={11} className="col-9">
          <Row className="d-flex flex-row mx-1">
            <div className="dropDown">
              <select
                type="select"
                size="sm"
                className="btn__dropdown"
                value={selected.device_id}
                onChange={(e) => setSelected(deviceArr.filter(el => (el.device_id === e.target.value))[0])}
              >
                {(deviceArr.length > 0) && deviceArr.map((el, i) => <option value={el.device_id} key={i} > {el.device_id} </option>)}
              </select>
            </div>
            <div className="batteryBox">
              <div className="colBorder">
                <Row className="justify-content-center"><img src="/img/pcsImage.png" alt="pv-pcs" className="pv-pcs" />
                </Row>
                <Row className="mb-4 mt-4 justify-content-center">
                  {pcsData !== null && <span className="pcsdata">{pcsData.device_id}</span>}
                </Row>
              </div>
            </div>
            <Col md={8} sm={10} lg={7} className="individual-battery">
              <div className="scroll-bar">
                {(pcsData !== null) && <Table className="power__data ">
                  <tbody>
                    <tr>
                      <td>累計充電電力量</td>
                      <td>{formatPower(pcsData.chrg_power, 2)}h</td>
                    </tr>
                    <tr>
                      <td>累計放電電力量	</td>
                      <td>{formatPower(pcsData.dischrg_power, 2)}h</td>
                    </tr>
                    <tr>
                      <td>充放電電力	</td>
                      <td>{formatPower(pcsData.real_power, 2)}</td>
                    </tr>
                    <tr>
                      <td>力率</td>
                      <td>{formatNumber(pcsData.power_factor, 3)}</td>
                    </tr>
                    <tr>
                      <td>周波数</td>
                      <td>{formatNumber(pcsData.freq, 2)}Hz</td>
                    </tr>
                    <tr>
                      <td>充電電圧</td>
                      <td>{formatNumber(pcsData.chrg_volt, 2)}V</td>
                    </tr>
                    <tr>
                      <td>充電電流</td>
                      <td>{formatNumber(pcsData.chrg_curr, 2)}A</td>
                    </tr>
                    <tr>
                      <td>放電電圧</td>
                      <td>{formatNumber(pcsData.dischrg_volt, 2)}V</td>
                    </tr>
                    <tr>
                      <td>放電電流</td>
                      <td>{formatNumber(pcsData.dischrg_curr, 2)}A</td>
                    </tr>
                    <tr>
                      <td>SOC</td>
                      <td>{pcsData.soc}%</td>
                    </tr>
                    <tr>
                      <td>SOH</td>
                      <td>{pcsData.soh}%</td>
                    </tr>
                    <tr>
                      <td>バックアップ電源領域の最小幅</td>
                      <td>{pcsData.bkup_power_min}%</td>
                    </tr>
                    <tr>
                      <td>名目容量</td>
                      <td>{formatPower(pcsData.nominal_capacity, 2)}h</td>
                    </tr>
                    <tr>
                      <td>累計系統受電電力量</td>
                      <td>{formatPower(pcsData.sys_power_send, 2)}h</td>
                    </tr>
                    <tr>
                      <td>累計系統送電電力量</td>
                      <td>{formatPower(pcsData.sys_power_received, 2)}h</td>
                    </tr>
                    <tr>
                      <td>系統電圧（A相）</td>
                      <td>{formatNumber(pcsData.sys_volt, 2)}V</td>
                    </tr>
                    <tr>
                      <td>系統電流（A相）</td>
                      <td>{formatNumber(pcsData.sys_curr, 2)}A</td>
                    </tr>
                    <tr>
                      <td>PCS状態</td>
                      <td>{pcsData.status_code}</td>
                    </tr>
                    <tr>
                      <td>イベントコード</td>
                      <td>{pcsData.event_code}</td>
                    </tr>
                    {/* <tr>
                      <td>通信エラー</td>
                      <td>{pcsData.work_status}</td>
                    </tr> */}
                  </tbody>
                </Table>}
              </div>
            </Col>
          </Row>
        </Col>
      </Row>}





    </>
  );
};

export default TableBattery;
